import { authService } from '@/services/authService';
import { authTokenManager } from '@/requestHandler/authTokenManager';

export default {
  namespaced: true,
  state: () => ({
    isAuthenticated: false,
    user: null
  }),
  mutations: {
    SET_AUTH_STATUS(state, status) {
      state.isAuthenticated = status;
    },
    SET_USER(state, user) {
      state.user = user;
    }
  },
  actions: {
    async login({ commit }, { email, password, rememberMe }) {
      try {
        await authService.login(email, password, rememberMe);
        const user = await authService.me();
        commit('SET_AUTH_STATUS', true);
        commit('SET_USER', user);
        return true;
      } catch (error) {
        console.error('Login failed:', error);
        return false;
      }
    },
    async logout({ commit }) {
      await authTokenManager.clear();
      commit('SET_AUTH_STATUS', false);
      commit('SET_USER', null);
    },
  
    async checkAuth({ commit }) {
      const isAuthenticated = authTokenManager.isAuthenticated();
      let user = null;
      if (isAuthenticated) {
        try {
          user = await authService.me();
          commit('SET_AUTH_STATUS', isAuthenticated);
          commit('SET_USER', user);
        } catch (error) {
          console.error('Failed to get user data:', error);
          authTokenManager.clear();
          commit('SET_AUTH_STATUS', false);
          commit('SET_USER', null);
        }
      }
    }
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    user: state => state.user,
    isLoggedIn: state => state.isAuthenticated,
    userType: state => state.user?.user_type_id ?? null,
  }
};